import { InputHTMLAttributes, forwardRef, useId, useState } from 'react';
import styles from './styles.module.css';
import Input from '../Input';
import Caption, { CaptionsUnderForm } from '../Caption';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';

type Props = {
  label: string;
  type?: 'text' | 'password' | 'email';
  error?: string;
  text?: string;
} & InputHTMLAttributes<HTMLInputElement>;

const FormBlockItem = forwardRef<HTMLInputElement, Props>(
  ({ label, type, error, text, ...props }: Props, ref) => {
    const id = useId();

    const [isRevealPassword, setIsRevealPassword] = useState(false);
    const underText = () => {
      if (error) {
        return <Caption variants={['error']}>{error}</Caption>;
      }
      if (text) {
        return <Caption variants={['text']}>{text}</Caption>;
      }
    };

    return (
      <div
        className={classNames(
          styles.host,
          props.name === 'newPassword' || (error && styles.error)
        )}
      >
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
        <div className={styles.input}>
          <Input
            variants={[
              'fit',
              ...(error !== undefined ? ['error' as const] : []),
              ...(type === 'password' ? ['with-button' as const] : []),
            ]}
            {...props}
            type={type === 'password' && isRevealPassword ? 'text' : type}
            id={id}
            ref={ref}
          />
          {type === 'password' && (
            <button
              type="button"
              aria-label="パスワードの表示・非表示を切り替える"
              className={styles.togglePasswordVisibility}
              onClick={() => setIsRevealPassword((prevState) => !prevState)}
            >
              <FontAwesomeIcon icon={isRevealPassword ? faEye : faEyeSlash} />
            </button>
          )}
        </div>
        <CaptionsUnderForm>{underText()}</CaptionsUnderForm>
      </div>
    );
  }
);
FormBlockItem.displayName = 'FormBlockItem';

export default FormBlockItem;
